<a [routerLink]="allowOnClick ? docId : null"
   (contextmenu)="onClickCard($event); trackClickedArticle()"
   (middleclick)="onClickCard($event); trackClickedArticle()"
   (click)="onClickCard($event); trackClickedArticle()"
   [state]="{context: text}"
   data-cy="article-card"
>
  <div id="card-{{docId}}" [ngClass]="{'preview': isPreview}" class="document-card" [style]="cardStyles">
    <div class="document-info">
      <div class="document-source">
        <i class="ph-bold ph-newspaper color-basic-600"></i>
        <div class="fw-600">{{source}}</div>
      </div>
      <div class="document-publication-date">
        <i class="ph-bold ph-calendar-check color-basic-600"></i>
        @if (publicationDate) {
          <div>{{publicationDate | date:'dd MMMM yyyy':'':'fr' }}</div>
        } @else {
          <div>{{ 'content.date_not_detected' | translate }}</div>
        }
      </div>
    </div>

    <!--line containing folder icon, title and occurrence badge-->
    <div class="document-head">
      @if (bookmarkPaths && bookmarkPaths.length > 0) {
        <mat-icon class="icon-24" svgIcon="saved-folder-icon-green"></mat-icon>
      }
      <div class="document-title"
           data-cy="article-card-title"
           [innerHTML]="title | articleTitleCase">
      </div>
      @if (showOccurrences && nbOccurrences) {
        <div class="document-occurrences">
          {{ nbOccurrences }} {{
            nbOccurrences === 1
              ? ('content.occurrence' | translate)
              : ('content.occurrences' | translate)
          }}
        </div>
      }
    </div>

    <div class="document-territories" id="territory-section-{{docId}}">
      <i class="ph-bold ph-map-pin"></i>
      @if (territories && territories.length) {
        <div class="document-territories-list" id="territory-list-{{docId}}">
          @for (territory of territories; track territory.uid; let idx = $index) {
            <span>{{territory['name']}}</span>
            @if (idx !== territories.length - 1) {
              <span>|</span>
            }
          }
        </div>
        @if (displayReadMore) {
          <div id="read-more-{{docId}}"
               class="document-territories-more"
               (click)="onReadMoreClick($event)"
               [ngbTooltip]="territoryTooltip"
               tooltipClass="simple-tooltip"
               placement="bottom-right">
            <i class="ph-bold ph-plus"></i>
            <div>{{"content.see-more"| translate}}</div>
          </div>
        }
      } @else {
        <div class="document-no-territories">
          {{'content.non-detected-territory' | translate}}
        </div>
      }
    </div>
    <div class="document-text" data-cy="article-card-text" [innerHTML]="text"></div>
  </div>
</a>

<ng-template #territoryTooltip class="territory-tooltip">
      <span *ngFor="let territory of territories; let i = index">
            <span class="territory-name fw-bold color-white">{{territory['name']}}</span>
            <span *ngIf="territories && i < territories.length - 1"
                  class="separator color-basic-600 fw-light"> | </span>
      </span>
</ng-template>
